// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen-header {
  background-color: var(--color-header-background);
}

.fa-angle-left {
  font-weight: 600;
  font-size: 20px;
  cursor: pointer;
}

.title {
  font-size: 20px;
  font-weight: 600;
}

.nav-tabs > li.active > a {
  border-bottom: 2px solid black;
  font-weight: 500;
  color: black;
}

.nav-link {
  padding: 0px;
}

.nav-tabs .nav-link {
  border: none;
  color: black;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border: none;
}

.nav-item {
  padding: 0px 50px 0px 0px;
}

.stepper-header .content {
  margin: 25px 0px 0px 0px;
}
.stepper-header .content .step-name {
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  align-items: center;
  text-align: center;
  color: var(--color-card-text);
  padding: 10px 0px 5px 0px;
}
.stepper-header .content .step-instruction {
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: var(--color-card-text);
  padding: 5px 0px 20px 0px;
}
.stepper-header .content .navbar {
  display: flex;
  justify-content: center;
  width: 100%;
}

/******************** stepper***************/
.stepper .stepper-horizontal {
  float: left;
  margin-bottom: 12px;
  z-index: 1;
  border-bottom: 2px solid var(--color-secondary);
  width: 60px;
}

.active-circle {
  background: #007a9d;
  border-radius: 50%;
  height: 11px;
  width: 11px;
  position: absolute;
  margin: 6px 0px 0px 6px;
}

/******************** Brand Header ***************/
.brand-header {
  background-color: var(--color-header-background);
  color: var(--color-header-text);
}
.brand-header .brand-logos img {
  max-height: 150px;
  max-width: 150px;
  min-height: 75px;
  min-width: 75px;
}
.brand-header .brand-desc {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  color: var(----color-header-text);
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/screen-header/screen-header.component.scss"],"names":[],"mappings":"AACA;EACE,gDAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;AAAF;;AAIA;EACE,8BAAA;EACA,gBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;AADF;;AAIA;;EAEE,YAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAKE;EACE,wBAAA;AAFJ;AAGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;AADN;AAII;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;AAFN;AAKI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAHN;;AAOA,4CAAA;AAEE;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,+CAAA;EACA,WAAA;AALJ;;AASA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AANF;;AAQA,kDAAA;AACA;EACE,gDAAA;EACA,+BAAA;AALF;AAQI;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AANN;AAUE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AARJ","sourcesContent":["\n.screen-header {\n  background-color: var(--color-header-background);\n}\n\n.fa-angle-left {\n  font-weight: 600;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n\n.nav-tabs > li.active > a {\n  border-bottom: 2px solid black;\n  font-weight: 500;\n  color: black;\n}\n\n.nav-link {\n  padding: 0px;\n}\n\n.nav-tabs .nav-link {\n  border: none;\n  color: black;\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n  border: none;\n}\n\n.nav-item {\n  padding: 0px 50px 0px 0px;\n}\n\n.stepper-header {\n  .content {\n    margin: 25px 0px 0px 0px;\n    .step-name {\n      font-weight: 600;\n      font-size: 20px;\n      line-height: 150%;\n      align-items: center;\n      text-align: center;\n      color: var(--color-card-text);\n      padding: 10px 0px 5px 0px;\n    }\n\n    .step-instruction {\n      font-size: 16px;\n      line-height: 150%;\n      text-align: center;\n      color: var(--color-card-text);\n      padding: 5px 0px 20px 0px;\n    }\n\n    .navbar {\n      display: flex;\n      justify-content: center;\n      width: 100%;\n    }\n  }\n}\n/******************** stepper***************/\n.stepper {\n  .stepper-horizontal {\n    float: left;\n    margin-bottom: 12px;\n    z-index: 1;\n    border-bottom: 2px solid var(--color-secondary);\n    width: 60px;\n  }\n}\n\n.active-circle {\n  background: #007a9d;\n  border-radius: 50%;\n  height: 11px;\n  width: 11px;\n  position: absolute;\n  margin: 6px 0px 0px 6px;\n}\n/******************** Brand Header ***************/\n.brand-header {\n  background-color: var(--color-header-background);\n  color: var(--color-header-text);\n\n  .brand-logos {\n    img {\n      max-height: 150px;\n      max-width: 150px;\n      min-height: 75px;\n      min-width: 75px;\n    }\n  }\n\n  .brand-desc {\n    font-size: 30px;\n    font-weight: 700;\n    text-align: center;\n    color: var(----color-header-text);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
